'use client'

import { stringArray } from '@/app/utils/zod_stringArray'
import { useSearchParams } from '@/libraries/search-params'
import { z } from 'zod'

export function FilterTitle() {
  const [_, setState] = useSearchParams(
    z.object({
      categories: stringArray(),
      genres: stringArray(),
      color: z.string().default(''),
      countryCode: stringArray(),
    }),
  )

  // const hasFilter =
  //   state.categories.length > 0 || state.genres.length > 0 || state.color !== ''

  return (
    <div className="c-b4 flex items-center justify-between">
      <span>검색 필터</span>
      <span
        className="cursor-pointer text-french-bleu"
        onClick={() => {
          setState({
            categories: [],
            genres: [],
            color: '',
            countryCode: [],
          })
        }}>
        초기화
      </span>
    </div>
    // <p
    //   className={cn('c-h6 flex flex-row items-center gap-10 xl:c-h5', {
    //     'text-french-bleu': showIndicator && hasFilter,
    //   })}>
    //   <TuneIcon
    //     className={cn('h-24 w-24', {
    //       'fill-french-bleu': showIndicator && hasFilter,
    //     })}
    //   />{' '}
    //   <I18nTranslator text="common.filterLabel" />
    // </p>
  )
}
